import { useContext } from 'react';

import { type AppToastContextValue, AppToastContext } from '../components/toast';

export const useAppToast = (): AppToastContextValue => {
	const context = useContext(AppToastContext);
	if (!context) throw new Error('useAppToast must be used within an AppToastProvider');
	return context;
};
